import { render, staticRenderFns } from "./AccountProfileInfo.vue?vue&type=template&id=476dafa2&"
import script from "./AccountProfileInfo.vue?vue&type=script&lang=js&"
export * from "./AccountProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports